//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TDP.js";
import "../TDP/TDP.TemplateBaseRectangleBuilder.js";
import "../no/LineColorFontWidthBuilder.js";
import "../no/LineColorFontWidthBuilder.js";
let d=[[[1,"ColorWidth",0,"LineColorFontWidthBuilder",0],[0,"DefaultViewTypes",1,0],[0,"Label",1,0],[0,"ShowBorder",1,0],[0,"UserDefinedView",1,0]],[],[]];
SPLM.TDP.TemplateViewportBuilder = class extends SPLM.TDP.TemplateBaseRectangleBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.TDP.TemplateViewportBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.TDP.TemplateViewportBuilder.DefaultViewType = Object.freeze({
    "NotAssigned" : "NotAssigned", "Back" : "Back", "Bottom" : "Bottom", "Front" : "Front", "Isometric" : "Isometric", "Left" : "Left", "Right" : "Right", "Top" : "Top", "Trimetric" : "Trimetric", "UserDefined" : "UserDefined"});

export default SPLM;